import styled from 'styled-components';
import ExperimentalSvg from "../Experimental__Icon/Svg";
export var Container = styled.nav.withConfig({
  displayName: "Container",
  componentId: "sc-10qp852-0"
})(["display:flex;align-items:center;", "{[dir='rtl'] &{transform:rotate(180deg);}}"], ExperimentalSvg);